module.exports = __webpack_public_path__ + "img/uae-flag.71858498.png";